import type { ProductPlanListModel } from './ProductPlanListModel';
import { nanoid } from 'nanoid';
import type { CartProduct, SubscriptionType } from '@repositories/subscriptionRepository/subscription.types';

export type Order = {
  subscriptionType: SubscriptionType;
  startDate: string;
  endDate: string;
  request: string;
};
export class CartProductModel {
  private readonly _dto: CartProduct;
  private readonly _productPlans: ProductPlanListModel;
  private _subscriptionType?: SubscriptionType;
  private _startDate?: string;
  private _endDate?: string;
  private _request?: string;
  private _isModified: boolean;
  private _isChecked: boolean;
  private readonly _id: string;

  constructor(dto: CartProduct) {
    this._dto = dto;
    this._productPlans = dto.productPlans;
    this._subscriptionType = dto.subscriptionType;
    this._startDate = dto.startDate;
    this._endDate = dto.endDate;
    this._request = dto.request;
    this._isModified = dto.isModified;
    this._isChecked = dto.isChecked;
    this._id = dto.id ?? nanoid();
  }

  get originDTO(): CartProduct {
    return this._dto;
  }

  get id() {
    return this._id;
  }

  get productId() {
    return this._dto.productId;
  }

  get productName() {
    return this._dto.productName;
  }

  get planId() {
    return this._dto.planId;
  }

  get planName() {
    return this._dto.planName;
  }

  get inquiry(): string {
    return this._dto.inquiry ?? '';
  }

  get requester(): string {
    return this._dto.requester ?? '';
  }

  get description(): string | undefined {
    return this._dto.description;
  }

  get productPlans() {
    return this._productPlans;
  }

  get isChecked(): boolean {
    return this._isChecked;
  }

  setCheck(flag: boolean) {
    this._isChecked = flag;
  }

  get isModified(): boolean {
    return this._isModified;
  }

  get iconUrl() {
    return this._dto.iconUrl;
  }

  get thumbnailUrl() {
    return this._dto.thumbnailUrl;
  }

  get companyName() {
    return this._dto.companyName;
  }

  get subscriptionType() {
    return this._subscriptionType;
  }

  get startDate() {
    return this._startDate;
  }

  get endDate() {
    return this._endDate;
  }

  get request() {
    return this._request;
  }

  setOrder(order: Order) {
    this._subscriptionType = order.subscriptionType;
    this._startDate = order.startDate;
    this._endDate = order.endDate;
    this._request = order.request;
    this._isModified = true;
  }

  isSame(target: CartProductModel): boolean {
    return this.id === target.id;
  }
}
